<template>
  <div id="main-message">
     
     <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="10">
            <vs-card>
            <div slot="header">
                <h3>
                Bienvenido a Mapgrafi
                </h3>
            </div>
            <div>
                <p  v-show="statusComputed == 0 " class="messagePerfect">Su email ha sido confirmado satisfactoriamente, por favor<router-link tag="div" to="/account/login" style="float:right; margin-left: 5%;"> <a style="text-decoration:underline;">Inicie sesión</a></router-link>.</p>
                <p  v-show="statusComputed == 1 " class="messagePerfect">Su email ha sido confirmado anteriormente, por favor<router-link tag="div" to="/account/login" style="float:right; margin-left: 5%;"> <a style="text-decoration:underline;">Inicie sesión</a></router-link>.</p>
                <p  v-show="statusComputed == -1 " class="messagePerfect">El link para confirmar su registro expiró, si desea habilitar nuevamente su proceso por favor haga <router-link tag="div" to="/account/login" style="float:right; margin-left: 5%;"> <a style="text-decoration:underline;">Clic aquí</a></router-link>.</p>
                 <p>
                    <br>
                    <br>
                </p>
            </div>
            <div slot="footer">
                <vs-row vs-justify="flex-end">
                        <router-link tag="div" to="/" style="float:left; margin-left: 5%;"> 
                            <vs-button color="primary" icon="home" ></vs-button>
                        </router-link>
                    <router-link tag="div" to="/account/login" style="float:left; margin-left: 5%;"> 
                        <vs-button color="primary" >Iniciar Sesión</vs-button>
                    </router-link>
                </vs-row>
            </div>
            </vs-card>
        </vs-col>
     </vs-row>
  </div>
</template>

<script>

export default {
    data(){
        return {
            status  :   null,
        }
    },
    computed: {
        statusComputed(){
            var status = this.status;
            return status;
        }
    },
    methods: {
        loadValidatorMail(){
            this.$vs.loading();
				this.$http.get(this.$store.state.domain+`mapgrafi/seguridad/usuario-confirmacion-registro/`+this.$route.params.id)
				.then((response) => {
                    this.$vs.loading.close(); 
                    if(response.status == 500)  throw 'Servidor no responde.';
                        if(response.status == 200)
                            if(response.data.existeError)   location.reload();
                            else  this.status =   response.data.data;
				})
                .catch(error => { 
                    location.reload();
                    this.$vs.notify({
							time:8000,
							title: 'Success',
							text:  error,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
				    });
			    })
        }
    },
    created(){
        this.loadValidatorMail();
    }
}
</script>

<style lang="scss" scoped>
#ecommerce-wishlist-demo {
    .item-view-primary-action-btn {
        color: #2c2c2c !important;
        background-color: #f6f6f6;
        min-width: 50%;
    }

    .item-view-secondary-action-btn {
        min-width: 50%;
    }
}
.messagePerfect{
    font-size: 20px;
    font-weight: 400;
}
</style>
